import { makeEntityScaffold } from '@classpass/saga-tools';
import { deepExtract } from 'helpers/deep';

const flattenMsa = msa => ({
  id: msa.id,
  name: msa.name,
  alias: msa.alias,
  city: msa.city,
  display_name: msa.display_name,
  default_location: msa.default_location,
  currency_code: msa.currency_code,
  currency_format: msa.currency_format,
  country_code: deepExtract('country.code', msa),
  country_id: deepExtract('country.id', msa),
  price: msa.price,
  package_purchase: msa.package_purchase,
  timezone: msa.timezone,
  version: msa.version,
});

export const msas = makeEntityScaffold('SAGA.API.MSAS', (client, options) =>
  client.msas.getList(options).then(data => data.msas.map(flattenMsa))
);

export const msaById = makeEntityScaffold(
  'SAGA.API.MSA_BY_ID',
  (client, id) => client.msas.getById(id).then(flattenMsa),
  { defaultKey: 1 }
);

export const msaCreditStatById = makeEntityScaffold(
  'SAGA.API.MSA_CREDIT_STAT_BY_ID',
  (client, msaId) => client.msas.getCreditStats(msaId),
  { defaultKey: 1 }
);

export const holdPlanByMsa = makeEntityScaffold(
  'SAGA.API.HOLD_PLAN',
  (client, msaId, options = {}) => client.msas.getHoldPlan(msaId, options),
  { defaultKey: 1 }
);

export const zipCodeToLatLng = makeEntityScaffold(
  'SAGA.API.ZIP_CODE_TO_LATLNG',
  (client, countryCode, zip) =>
    client.locations.getByPostalCode(zip, {
      country_code: countryCode,
    }),
  { defaultKey: [1, 2] }
);
